import BaseService from "../BaseService";

export default class KontingentperiodeService extends BaseService {

  constructor() {
    super('kontingentperiode');
  }

  async neueVersenden(periode, elektronischerVersand, queryParams) {
    await this.getBackendListUrl()
    const url = this.createUrl(`${this.backendUrl}/${periode.id}/versenden`, {...queryParams, elektronischerVersand, status: 'NEU'})
    return this.checkError(
      fetch(url, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  createUrl(baseUrl, queryParams) {
    if (queryParams) {
      const url = new URL(baseUrl)
      const urlSearchParams = new URLSearchParams()
      Object.entries(queryParams).forEach(([key, value]) => {
        this.appendQueryParams(urlSearchParams, key, value)
      })
      url.searchParams.forEach((value, key) => {
        this.appendQueryParams(urlSearchParams, key, value)
      })
      return `${url.origin}${url.pathname}?${urlSearchParams.toString()}`
    } else {
      return baseUrl
    }
  }

  appendQueryParams(urlSearchParams, key, value) {
    if (value instanceof Array) {
      value.forEach(mutliValue => {
        urlSearchParams.append(key, mutliValue)
      })
    } else {
      urlSearchParams.append(key, value)
    }
  }

  readStatistic(periode) {
    return this.read(`statistic/${periode.id}`)
  }
}
